import Getters from "@/constants/store/getters";
import TaxonomyNames from "@/constants/taxonomy-names";

export default {
    [Getters.get_makes](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.make;
        })
            .options;
    },
    [Getters.get_bodies](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.body;
        })
            .options;
    },
    [Getters.get_colors](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.color;
        })
            .options;
    },
    [Getters.get_conditions](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.condition;
        })
            .options;
    },
    [Getters.get_transmissions](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.transmission;
        })
            .options;
    },
    [Getters.get_fuel_types](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.fuel_type;
        })
            .options;
    },
    [Getters.get_number_of_doors](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.number_of_door;
        })
            .options;
    },
    [Getters.get_drives](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.drive;
        })
            .options;
    },
    [Getters.get_holding_periods](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.holding_period;
        })
            .options;
    },
    [Getters.get_distances_from_me](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.distance_from_me;
        })
            .options;
    },
    [Getters.get_price_ranges](state) {
        if (!state.taxonomies.meta.fetched) {
            return [];
        }
        return state.taxonomies.data.find(item => {
            return item.name === TaxonomyNames.price_range;
        })
            .options;
    },

}
